import React, { useState, useEffect } from "react";
import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import {
  SelectDate,
  SelectPaymodeStatus,
  setOutletStatus,
} from "./../../utility/Redux/refresh";
import { FormatNumber2 } from "./../../utility/component/tools";
import { setloading } from "./../../utility/Redux/modal";
import { selectheader } from "./../../utility/Redux/security";
const PaymodeSale = ({ prefix }) => {
  const dispatch = useDispatch();
  const [Paymode, SetPaymode] = useState([]);
  const PaymodeStatus = useSelector(SelectPaymodeStatus);

  const checkDateData = useSelector(SelectDate);
  const headers = useSelector(selectheader);
  const getPaymodeDetails = () => {
    dispatch(setloading(true));
    axios
      .post(
        `/api/salesReports/payModeSaleReport`,
        {
          table_prefix: prefix,
          from_date: checkDateData,
          to_date: checkDateData,
        },
        {
          headers: headers,
        }
      )
      .then((d) => {
        let data = d.data;

        SetPaymode(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(setloading(false));
      });
  };

  useEffect(() => {
    getPaymodeDetails();
  }, [PaymodeStatus, checkDateData, prefix]);

  return (
    <>
      {Paymode[0]?.DATE ||
      Paymode[1]?.DATE ||
      Paymode[2]?.DATE ||
      Paymode[3]?.DATE ||
      Paymode[4]?.DATE ? (
        <>
          <section className="dashboard-section">
            <div className="dashboard-section-title"><span>Payment summary</span><small>How customers paid today</small></div>
            <div>
              <div>
                {Paymode.map((d, index) => {
                  return (
                    <div
                      key={index}
                      className="grid d:grid-cols-6 ll:grid-cols-7 t:grid-cols-4 grid-cols-2 gap-2 p:gap-2 l:grid-cols-5 "
                    >
                      {!d.CASH_AMT == 0 ? (
                        <div
                          className="dashboard-value-card"
                        >
                          <span className="dashboard-value-label">Cash</span>

                          <div
                            className="dashboard-value-amount"
                          >
                            ₹ {FormatNumber2(d.CASH_AMT)}
                          </div>
                        </div>
                      ) : null}

                      {!d.CARD_AMT == 0 ? (
                        <div
                          className="dashboard-value-card"
                        >
                          <span className="dashboard-value-label">Card</span>

                          <div
                            className="dashboard-value-amount"
                          >
                            ₹ {FormatNumber2(d.CARD_AMT)}
                          </div>
                        </div>
                      ) : null}

                      {!d.CHQ_AMT == 0 ? (
                        <div
                          className="dashboard-value-card"
                        >
                          <span className="dashboard-value-label">Cheque</span>

                          <div
                            className="dashboard-value-amount"
                          >
                            ₹ {FormatNumber2(d.CHQ_AMT)}
                          </div>
                        </div>
                      ) : null}

                      {!d.BTC_AMT == 0 ? (
                        <div
                          className="dashboard-value-card"
                        >
                          <span className="dashboard-value-label">Bank transfer</span>

                          <div
                            className="dashboard-value-amount"
                          >
                            ₹ {FormatNumber2(d.BTC_AMT)}
                          </div>
                        </div>
                      ) : null}

                      {!d.ROOM_CREDIT == 0 ? (
                        <div
                          className="dashboard-value-card"
                        >
                          <span className="dashboard-value-label">Room credit</span>

                          <div
                            className="dashboard-value-amount"
                          >
                            ₹ {FormatNumber2(d.ROOM_CREDIT)}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </>
      ) : null}
    </>
  );
};

export default PaymodeSale;
